module.exports = __webpack_public_path__ + "img/thumb-jaxjox@2x.15a03a9d.png";